import Grid from "@afa-shared/afa-components/dist/Grid";
import Heading from "@afa-shared/afa-components/dist/Heading";
import Text from "@afa-shared/afa-components/dist/Text";
import LinkBlock from "@components/LinkBlock";
import IvHeroImage from "@components/Medias/Image/IvHeroImage";

import { Context } from "types/context/Context";

import heroBlockStyles from "./InsuranceHeroBlock.module.css";

interface IHeroProps {
  heading: string;
  subheader?: string;
  ingress?: string;
  links: Array<any>;
  image: any;
  contentfulPreviewEntryId?: string;
  context?: Context;
}

const InsuranceHeroBlock = ({
  heading,
  subheader,
  ingress,
  links,
  image,
  contentfulPreviewEntryId,
  context,
}: IHeroProps) => {
  const buttonLinks = links?.filter((item) => item?.link?.variant === "Knapp");
  const textLinks = links?.filter((item) => item?.link?.variant !== "Knapp");

  return (
    <div className={heroBlockStyles.heroBlock} id={"innehall"}>
      <Grid className={heroBlockStyles.grid} container alignItems={"center"} margin={"0 auto"}>
        <div className={heroBlockStyles.contentWrapper}>
          <div className={heroBlockStyles.headingWrapper}>
            <div>
              <Heading
                variant="h1"
                children={heading}
                removeMargin
                className={heroBlockStyles.heading}
                data-contentful-entry-id={contentfulPreviewEntryId}
                data-contentful-field-id="heading"
              />
              {subheader && <span className={heroBlockStyles.subheader}>{subheader}</span>}
            </div>
            {ingress && (
              <Text
                variant={"preamble"}
                children={ingress}
                removeMargin
                className={heroBlockStyles.text}
                data-contentful-entry-id={contentfulPreviewEntryId}
                data-contentful-field-id="preamble"
              />
            )}
          </div>
          {buttonLinks?.length > 0 && (
            <div className={heroBlockStyles.buttonWrapper}>
              {buttonLinks?.map((item: any, index: number) => {
                return <LinkBlock key={index} blockData={item?.link} context={context} isBarker />;
              })}
            </div>
          )}
          {textLinks?.length > 0 && (
            <div className={heroBlockStyles.linkWrapper}>
              {textLinks?.map((item: any, index: number) => {
                return <LinkBlock key={index} blockData={item?.link} />;
              })}
            </div>
          )}
        </div>
        <div className={heroBlockStyles.heroImageWrapper}>
          <IvHeroImage
            image={image}
            className={heroBlockStyles.ivHeroImage}
            contentfulPreviewEntryId={image?.imageBlock?.sys?.id}
            contentfulPreviewImageFieldId={"ivImage"}
          />
        </div>
      </Grid>
    </div>
  );
};
export default InsuranceHeroBlock;
